type PaymentProcessorSettings = {
  globalPay?: boolean;
  nmi?: boolean;
  heartland?: boolean;
};

const SETTINGS_PAYMENT_PROCESSOR_MAPPINGS = {
  GLOBAL_PAY: 'Global Pay',
  NMI: 'NMI',
  HEARTLAND: 'Heartland',
  NONE: 'None',
} as const;

export const getPaymentProcessor = <T extends PaymentProcessorSettings>(
  settings: NonNullable<T>,
) => {
  if (settings?.globalPay) return SETTINGS_PAYMENT_PROCESSOR_MAPPINGS.GLOBAL_PAY;
  if (settings?.nmi) return SETTINGS_PAYMENT_PROCESSOR_MAPPINGS.NMI;
  if (settings?.heartland) return SETTINGS_PAYMENT_PROCESSOR_MAPPINGS.HEARTLAND;
  return SETTINGS_PAYMENT_PROCESSOR_MAPPINGS.NONE;
};
